module.exports = __webpack_public_path__ + "static/Frogsong0-8b57b2a1ef2f1e12d2a75b2d8649e424.webp";